export const gameHighlights = [
  {
    id: 1,
    title: "Warzone Quad Wipe",
    game: "Call of Duty: Warzone",
    image: "https://public.readdy.ai/ai/img_res/562cb9c5ea5ad1929edcc97272ce22a3.jpg",
    kills: 24,
    damage: "12,480",
    placement: "1st",
    description: "Solo-v-squad comeback after full team elimination. Pure insanity.",
    date: "Mar 2026",
    tag: "CLUTCH",
  },
  {
    id: 2,
    title: "Ranked Apex Climb",
    game: "Apex Legends",
    image: "https://readdy.ai/api/search-image?query=apex%20legends%20battle%20royale%20victory%20screen%20dramatic%20dark%20stormy%20battlefield%20neon%20glow%20purple%20atmosphere%20energy%20weapons%20last%20squad%20standing&width=400&height=250&seq=game2&orientation=landscape",
    kills: 18,
    damage: "9,220",
    placement: "1st",
    description: "Diamond to Masters push — 18 kills, full lobby domination.",
    date: "Feb 2026",
    tag: "RANKED",
  },
  {
    id: 3,
    title: "Elden Ring No-Hit Run",
    game: "Elden Ring",
    image: "https://readdy.ai/api/search-image?query=elden%20ring%20dark%20fantasy%20boss%20fight%20magical%20warrior%20glowing%20sword%20purple%20fire%20effects%20dramatic%20atmospheric%20fog%20epic%20dragon%20battle%20cinematic&width=400&height=250&seq=game3&orientation=landscape",
    kills: 1,
    damage: "Boss",
    placement: "1st Clear",
    description: "Malenia, Blade of Miquella — defeated without taking a single hit.",
    date: "Jan 2026",
    tag: "NO-HIT",
  },
  {
    id: 4,
    title: "Valorant Ace Round",
    game: "Valorant",
    image: "https://readdy.ai/api/search-image?query=valorant%20tactical%20shooter%20ace%20round%20neon%20glowing%20agents%20dark%20map%20purple%20cyan%20energy%20effects%20competitive%20esports%20dramatic%20cinematic&width=400&height=250&seq=game4&orientation=landscape",
    kills: 5,
    damage: "5,000",
    placement: "Win",
    description: "Pistol round ACE on Split. Enemy team had no idea what hit them.",
    date: "Mar 2026",
    tag: "ACE",
  },
  {
    id: 5,
    title: "League Pentakill",
    game: "League of Legends",
    image: "https://readdy.ai/api/search-image?query=league%20of%20legends%20pentakill%20magical%20champion%20glowing%20energy%20explosion%20dark%20arena%20purple%20gold%20light%20epic%20team%20fight%20cinematic&width=400&height=250&seq=game5&orientation=landscape",
    kills: 5,
    damage: "Pentakill",
    placement: "Win",
    description: "Mid-lane Zed pentakill that ended the game in spectacular fashion.",
    date: "Feb 2026",
    tag: "PENTA",
  },
  {
    id: 6,
    title: "World of Warcraft Raid",
    game: "World of Warcraft",
    image: "https://readdy.ai/api/search-image?query=world%20of%20warcraft%20heroic%20raid%20boss%20massive%20dragon%20dark%20dungeon%20glowing%20purple%20magic%20spells%20dramatic%20lighting%20guild%20team%20fight%20cinematic%204k&width=400&height=250&seq=game6&orientation=landscape",
    kills: 1,
    damage: "Mythic",
    placement: "World First",
    description: "Mythic difficulty world first guild progression kill. Guild screaming in Discord.",
    date: "Jan 2026",
    tag: "WORLD FIRST",
  },
];

export const socialPlatforms = [
  {
    id: 1,
    platform: "Twitch",
    handle: "@AidanBarrettGG",
    followers: "42.8K",
    description: "Live gaming sessions every Tue, Thu & Sat. Variety content with vibes.",
    icon: "ri-twitch-fill",
    color: "#9147ff",
    url: "#",
    stat: "followers",
    extra: "Avg 2.1K viewers",
  },
  {
    id: 2,
    platform: "YouTube",
    handle: "AidanBarrettGG",
    followers: "128K",
    description: "Weekly highlights, full VODs, tier lists and gaming breakdowns.",
    icon: "ri-youtube-fill",
    color: "#ff0000",
    url: "#",
    stat: "subscribers",
    extra: "4.2M total views",
  },
  {
    id: 3,
    platform: "Twitter / X",
    handle: "@AidanGaming",
    followers: "31.2K",
    description: "Hot takes, clip drops, tournament updates and memes. Daily posts.",
    icon: "ri-twitter-x-fill",
    color: "#e2e8f0",
    url: "#",
    stat: "followers",
    extra: "5M impressions/mo",
  },
  {
    id: 4,
    platform: "Discord",
    handle: "Aidan's Lair",
    followers: "8.7K",
    description: "Join the community. Scrims, giveaways, gaming talk 24/7.",
    icon: "ri-discord-fill",
    color: "#5865f2",
    url: "#",
    stat: "members",
    extra: "500+ online daily",
  },
  {
    id: 5,
    platform: "TikTok",
    handle: "@AidanBarrettGG",
    followers: "215K",
    description: "Short clips, funny moments, and gaming tips that actually work.",
    icon: "ri-tiktok-fill",
    color: "#ff0050",
    url: "#",
    stat: "followers",
    extra: "12M total likes",
  },
  {
    id: 6,
    platform: "Instagram",
    handle: "@AidanBarrett",
    followers: "19.4K",
    description: "Setup shots, event highlights, and behind the scenes content.",
    icon: "ri-instagram-fill",
    color: "#e1306c",
    url: "#",
    stat: "followers",
    extra: "Gaming lifestyle",
  },
];

export const streamSchedule = [
  { day: "Tuesday", time: "7PM – 11PM EST", game: "Warzone Ranked", isLive: false },
  { day: "Thursday", time: "8PM – 12AM EST", game: "Variety Night", isLive: false },
  { day: "Saturday", time: "3PM – 9PM EST", game: "Long Session — All Games", isLive: true },
  { day: "Sunday", time: "2PM – 5PM EST", game: "Community Games", isLive: false },
];

export const recentVods = [
  {
    id: 1,
    title: "Warzone Ranked Grind — Road to Iridescent",
    duration: "4h 22m",
    views: "18.4K",
    date: "2 days ago",
    image: "https://readdy.ai/api/search-image?query=live%20stream%20gaming%20thumbnail%20dark%20cyberpunk%20background%20neon%20purple%20glow%20intense%20gaming%20moment%20dramatic%20lighting%20warzone%20streamer&width=320&height=180&seq=stream1&orientation=landscape",
  },
  {
    id: 2,
    title: "Apex Legends Season 24 — Masters Push Day 3",
    duration: "3h 08m",
    views: "12.1K",
    date: "5 days ago",
    image: "https://readdy.ai/api/search-image?query=apex%20legends%20ranked%20stream%20thumbnail%20dark%20purple%20neon%20glow%20dramatic%20live%20gaming%20esports%20cinematic&width=320&height=180&seq=stream2&orientation=landscape",
  },
  {
    id: 3,
    title: "Elden Ring No-Hit Challenge — Attempt #31",
    duration: "5h 55m",
    views: "24.7K",
    date: "1 week ago",
    image: "https://readdy.ai/api/search-image?query=elden%20ring%20dark%20fantasy%20stream%20thumbnail%20boss%20fight%20no%20hit%20run%20dramatic%20purple%20atmospheric%20magical%20effects&width=320&height=180&seq=stream3&orientation=landscape",
  },
];

export const aboutStats = [
  { label: "Years Gaming", value: "15+" },
  { label: "Hours Streamed", value: "4,200+" },
  { label: "Total Followers", value: "450K+" },
  { label: "Games Beaten", value: "300+" },
];

export const featuredGames = [
  "Call of Duty", "Apex Legends", "Elden Ring", "Valorant", "League of Legends", "WoW",
];
